import { createFileRoute } from "@tanstack/react-router";

// `view` (Thẻ / Bảng) của "Đơn hậu kỳ" — link chia sẻ mở đúng dạng (28/10/2026).
type RetouchSearch = { tab?: string | undefined; view?: "cards" | "table" | undefined };

export const Route = createFileRoute("/_app/retouch/")({
  validateSearch: (search: Record<string, unknown>): RetouchSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
    view: search.view === "cards" || search.view === "table" ? search.view : undefined,
  }),
});
